import { currentPattern, datelessPattern, prefixPattern, suffixPattern } from "../../lib/vehicle/regValidation.js";

export function cleanRegistration(value = "") {
  return String(value).toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 7);
}

export function isValidUkRegistration(value) {
  const registration = cleanRegistration(value);
  return currentPattern.test(registration)
    || prefixPattern.test(registration)
    || suffixPattern.test(registration)
    || datelessPattern.test(registration);
}

export function formatUkRegistration(value) {
  const registration = cleanRegistration(value);
  if (currentPattern.test(registration)) return `${registration.slice(0, 4)} ${registration.slice(4)}`;
  if (prefixPattern.test(registration)) return `${registration.slice(0, -3)} ${registration.slice(-3)}`;
  if (suffixPattern.test(registration)) return `${registration.slice(0, 3)} ${registration.slice(3)}`;
  return registration;
}

// Loading steps shown while a vehicle page opens (homepage and vehicle page search).
export const LOOKUP_STEP_MS = 1400;
export function lookupSteps(displayReg) {
  return [`Finding ${displayReg}`, "Checking tax and MOT", "Opening vehicle page"];
}
